import { render } from "./ZioSummary.vue?vue&type=template&id=37c87243&scoped=true"
import script from "./ZioSummary.vue?vue&type=script&lang=js"
export * from "./ZioSummary.vue?vue&type=script&lang=js"

import "./ZioSummary.vue?vue&type=style&index=0&id=37c87243&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c87243"]])

export default __exports__